import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import LoginLab from "../views/Lab/Login-Lab.vue";
import LoginStudio from "../views/Studio/Login.vue";
import DashboardLab from "../views/Lab/Dashboard-Lab.vue";
import Pratica from "../views/Lab/Pratica.vue";
import CreatePratica from "../views/Studio/Create-Pratica.vue";
import CreateBolla from "../views/Lab/Create-Bolla.vue";
import CreateCertificazione from "../views/Lab/Create-Certificazione.vue";
import DashboardStudio from "../views/Studio/Dashboard.vue";
import Paziente from "../views/Studio/Paziente.vue";
import Dottore from "../views/Studio/Dottore.vue";
import Bolle from "../views/Studio/Bolle.vue";
import Admin from "../views/Studio/Admin.vue";
import NuovoUtente from "../views/Studio/Nuovo-Utente.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/login-lab",
    name: "LoginLab",
    component: LoginLab
  },
  {
    path: "/login-studio",
    name: "LoginStudio",
    component: LoginStudio
  },
  {
    path: "/dashboard-lab",
    name: "DashboardLab",
    component: DashboardLab
  },
  {
    path: "/pratica/:name~:id",
    name: "Pratica",
    component: Pratica
  },
  {
    path: "/nuova-pratica",
    name: "CreatePratica",
    component: CreatePratica
  },
  {
    path: "/nuova-bolla/:name~:id",
    name: "CreateBolla",
    component: CreateBolla
  },
  {
    path: "/nuova-certificazione/:name~:id",
    name: "CreateCertificazione",
    component: CreateCertificazione
  },
  {
    path: "/dashboard",
    name: "DasboardStudio",
    component: DashboardStudio
  },
  {
    path: "/paziente/:id",
    name: "Paziente",
    component: Paziente
  },
  {
    path: "/dottore/:id",
    name: "Dottore",
    component: Dottore
  },
  {
    path: "/bolle/:nome~:id/",
    name: "Bolle",
    component: Bolle
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin
  },
  {
    path: "/nuovo-utente",
    name: "Nuovo Utente",
    component: NuovoUtente
  }
];

const router = new VueRouter({
  // mode: "history",
  routes
});

export default router;
